import { Indicator } from '../../../Common/Charts/Indicator';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const LiveBirthsWithAnomalies = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <Indicator
            title={'Nascidos Vivos com Anomalias'}
            indicatorValue={chartData?.indicators?.liveBirthsWithAnomaliesPercentage}
            className='aligned-container'
        />
    );
};
